import clsx from 'clsx';
import { use, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { AppContext, AppProvider } from './contexts/app.context';
import Checkout from './routes/checkout/Checkout';
import Home from './routes/Home';
import About from './routes/subroutes/About';
import Contact from './routes/subroutes/Contact';
import Resume from './routes/subroutes/Resume';

import './App.scss';

const AppContent = () => {
  const { season, assignSeason } = use(AppContext);

  useEffect(() => {
    if (!season) assignSeason();
  }, [season, assignSeason]);

  return (
    <div className={clsx(season)}>
      <Routes>
        <Route path="/" element={<Home />}>
          <Route path="resume" element={<Resume />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
        </Route>
        <Route path="checkout" element={<Checkout />} />
      </Routes>
    </div>
  );
};

const App = () => {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
};

export default App;
